import $ from 'jquery';
import Swal from 'sweetalert2';

export function initTrash() {
    const pageId = $('#page-id').data('page');
    if (!pageId || !pageId.includes('trash')) return;

    const $form = $('#formTrashAction');
    const urlRestore = $form.data('url-restore');
    const urlPurge = $form.data('url-purge');
    const urlEmpty = $form.data('url-empty');

    console.log('[Trash] Initialized');

    // --- 1. Selection Handlers (Check All) ---
    $(document).on('change', '#check-all-trash', function() {
        const isChecked = $(this).prop('checked');
        $('.trash-row-select').prop('checked', isChecked);
        updateBulkActionUI();
    });

    $(document).on('change', '.trash-row-select', function() {
        const total = $('.trash-row-select').length;
        const checked = $('.trash-row-select:checked').length;
        $('#check-all-trash').prop('checked', total === checked && total > 0);
        updateBulkActionUI();
    });

    function updateBulkActionUI() {
        const checkedCount = $('.trash-row-select:checked').length;
        const $bulkContainer = $('#bulkActionsContainer');
        const $selectedCountText = $('#selectedCountText');

        if (checkedCount > 0) {
            $selectedCountText.text(checkedCount);
            $bulkContainer.removeClass('d-none').addClass('d-flex');
        } else {
            $bulkContainer.removeClass('d-flex').addClass('d-none');
        }
    }

    // --- 2. Action Execution Helper ---
    function executeTrashAction(url, actionTitle, confirmMessage, ids, icon = 'warning') {
        Swal.fire({
            title: actionTitle,
            text: confirmMessage,
            icon: icon,
            showCancelButton: true,
            confirmButtonColor: icon === 'danger' || icon === 'error' ? '#dc3545' : '#3085d6',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Ya, Eksekusi',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Memproses...',
                    text: 'Mohon tunggu sebentar',
                    allowOutsideClick: false,
                    didOpen: () => { Swal.showLoading(); }
                });

                const formData = new FormData($form[0]);
                if (Array.isArray(ids)) {
                    ids.forEach(id => formData.append('ids[]', id));
                } else if (ids) {
                    formData.append('ids[]', ids);
                }

                $.ajax({
                    url: url,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function(res) {
                        if (res.status === 'success') {
                            Swal.fire({
                                icon: 'success',
                                title: 'Berhasil!',
                                text: res.message,
                                timer: 1500,
                                showConfirmButton: false
                            }).then(() => {
                                window.location.reload();
                            });
                        } else {
                            Swal.fire('Gagal!', res.message || 'Terjadi kesalahan sistem', 'error');
                        }
                    },
                    error: function(xhr) {
                        Swal.fire('Error!', xhr.responseJSON?.message || 'Terjadi kesalahan jaringan', 'error');
                    }
                });
            }
        });
    }

    // --- 3. Click Handlers (Delegated) ---
    $(document).on('click', '.btn-restore-single', function() {
        const id = $(this).data('id');
        executeTrashAction(urlRestore, 'Pulihkan Data', 'Kembalikan data ini ke daftar aktif?', id, 'question');
    });

    $(document).on('click', '.btn-purge-single', function() {
        const id = $(this).data('id');
        executeTrashAction(urlPurge, 'Hapus Permanen', 'Peringatan: Data akan dihapus selamanya!', id, 'error');
    });

    $(document).on('click', '#btnBulkRestore', function() {
        const ids = $('.trash-row-select:checked').map(function() { return $(this).val(); }).get();
        executeTrashAction(urlRestore, 'Pulihkan Terpilih', `Kembalikan ${ids.length} data terpilih?`, ids, 'question');
    });

    $(document).on('click', '#btnBulkPurge', function() {
        const ids = $('.trash-row-select:checked').map(function() { return $(this).val(); }).get();
        executeTrashAction(urlPurge, 'Hapus Permanen Terpilih', `Hapus selamanya ${ids.length} data terpilih?`, ids, 'error');
    });

    $(document).on('click', '#btnEmptyTrash', function() {
        executeTrashAction(urlEmpty, 'Kosongkan Trash Modul', 'SEMUA data terhapus di modul ini akan dihapus permanen!', null, 'error');
    });

    $(document).on('click', '#btnEmptyAllTrash', function() {
        const originalModule = $form.find('input[name="module"]').val();
        $form.find('input[name="module"]').val('all');
        executeTrashAction(urlEmpty, 'Kosongkan Semua Trash', 'SEMUA data terhapus di SELURUH MODUL akan dihapus permanen! Tindakan ini tidak dapat dibatalkan.', null, 'error');
        // Restore original module value after submit starts
        setTimeout(() => {
            $form.find('input[name="module"]').val(originalModule);
        }, 200);
    });
}
